import React from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import {
    EuiPage,
    EuiPageBody,
    EuiPageContent,
    EuiPageContentBody,
    EuiPageContentHeader,
    EuiPageContentHeaderSection,
    EuiTitle,
    EuiButton,
    EuiFieldText,
    EuiForm,
    EuiFormRow,
    EuiSpacer,
    EuiFlexGroup,
    EuiFlexItem,
    EuiFieldPassword,
    EuiText,
} from "@elastic/eui";

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    height: 70vh;
`;

export default function ({ OnSave, isLoading, apiErrors }) {
    const { handleSubmit, register, errors } = useForm();
    const onSubmit = (values) => {
        OnSave(values);
    };

    const renderError = () => (
        <>
            <EuiFormRow>
                <EuiText
                    textAlign="center"
                    color="danger"
                    grow="true"
                >
                    {apiErrors}
                </EuiText>
            </EuiFormRow>
            <EuiSpacer />
        </>
    );

    return (
        <Container>
            <EuiPage>
                <EuiPageBody component="div">
                    <EuiPageContent
                        verticalPosition="center"
                        horizontalPosition="center"
                    >
                        <EuiPageContentHeader>
                            <EuiPageContentHeaderSection>
                                <EuiTitle>
                                    <h2>Login</h2>
                                </EuiTitle>
                            </EuiPageContentHeaderSection>
                        </EuiPageContentHeader>
                        <EuiPageContentBody>
                            <EuiFlexGroup
                                alignItems="center"
                                justifyContent="center"
                                direction="column"
                            >
                                <EuiFlexItem>
                                    <EuiForm component="form">
                                        <EuiFormRow
                                            label="Email"
                                            fullWidth
                                            error="Email is required and should follow this pattern i.e. john@example.com"
                                        >
                                            <EuiFieldText
                                                fullWidth
                                                name="email"
                                                icon="email"
                                                inputRef={register({
                                                    required: true,
                                                    pattern: /\S+@\S+\.\S+/,
                                                })}
                                            />
                                        </EuiFormRow>

                                        <EuiFormRow
                                            label="Password"
                                            fullWidth
                                            error="Password is required"
                                        >
                                            <EuiFieldPassword
                                                fullWidth
                                                name="password"
                                                icon="lock"
                                                inputRef={register({ required: true })}
                                            />
                                        </EuiFormRow>

                                        <EuiSpacer />

                                        {apiErrors && renderError()}

                                        <EuiButton
                                            type="submit"
                                            fill
                                            isLoading={isLoading}
                                            onClick={handleSubmit(onSubmit)}
                                        >
                                            Submit
                                        </EuiButton>
                                    </EuiForm>
                                </EuiFlexItem>
                            </EuiFlexGroup>
                        </EuiPageContentBody>
                    </EuiPageContent>
                </EuiPageBody>
            </EuiPage>
        </Container>
    );
}
